import { string } from "yup"

// Need formatter: XX-XXXXXXX
export const taxNumberSchema = string()
  .required()
  .test("length", function (value) {
    if (value.length === 0 || value.length === 9) return true
    else
      return this.createError({
        message: { key: "yup.common.string.length", values: { length: 9 } },
      })
  })
